import { KeywordResponse } from '../../models/monitor/KeywordResponse';

export const findTagIdInKeyword = (
  normalizedKeyword: string,
  keywordResponses: KeywordResponse[] | null
) => {
  if (!keywordResponses) {
    return null;
  }

  return findKeyword(normalizedKeyword, keywordResponses)?.tagId || null;
};

export const findKeyword = (normalizedKeyword: string, keywordResponses: KeywordResponse[]) =>
  keywordResponses.find((keywordResponse) => keywordResponse.normalizedKeyword === normalizedKeyword);
